import { useParams } from "react-router-dom";
import TypeWriterText from "../../components/TypeWriterText";
import { motion } from "framer-motion";

const legalPages = {
  "polityka-prywatnosci": {
    title: "Polityka prywatności",
    sections: [
      { heading: null, text: "Niniejsza Polityka prywatności określa zasady przetwarzania danych osobowych użytkowników oraz zasady korzystania z plików cookies w związku z korzystaniem ze strony internetowej hodowli Wolfe Vom Katzenberg." },
      { heading: "Administrator danych", text: "Administratorem danych osobowych jest:\n\nHodowla Wolfe Vom Katzenberg\nTelefon: +48 663 746 095\nE-mail: katzenberg.hodowla@gmail.com\n\nAdministrator dokłada szczególnej staranności, aby chronić prywatność użytkowników odwiedzających stronę internetową." },
      { heading: "Zakres zbieranych danych", text: "Administrator może przetwarzać dane przekazane dobrowolnie przez użytkownika, w szczególności:", list: ["imię i nazwisko", "numer telefonu", "adres e-mail", "miejscowość", "treść wiadomości przesłanej przez formularz kontaktowy lub e-mail"] },
      { heading: "Cel przetwarzania danych", text: "Dane osobowe mogą być przetwarzane w celu:", list: ["udzielenia odpowiedzi na zapytanie", "kontaktu w sprawie szczeniąt lub hodowli", "prowadzenia rezerwacji szczenięcia", "przekazywania informacji związanych z hodowlą", "zapewnienia prawidłowego działania strony internetowej"] },
      { heading: "Prawa użytkownika", text: "Każda osoba, której dane dotyczą, ma prawo do:", list: ["dostępu do swoich danych", "sprostowania danych", "usunięcia danych", "ograniczenia przetwarzania", "wniesienia sprzeciwu wobec przetwarzania", "cofnięcia zgody na przetwarzanie danych"] },
    ]
  },
  "rodo": {
    title: "Klauzula informacyjna RODO",
    sections: [
      { heading: null, text: "Zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 (RODO) informujemy, że:" },
      { heading: null, list: [
        "Administratorem danych osobowych jest Hodowla Wolfe Vom Katzenberg.",
        "Dane osobowe przetwarzane są w celu kontaktu z osobami zainteresowanymi hodowlą oraz udzielenia odpowiedzi na zapytania dotyczące szczeniąt.",
        "Podanie danych jest dobrowolne, jednak może być niezbędne do uzyskania odpowiedzi.",
        "Osoba, której dane dotyczą, ma prawo do dostępu do swoich danych, ich poprawiania oraz ich usunięcia."
      ]}
    ]
  },
  "regulamin": {
    title: "Regulamin strony",
    sections: [
      { heading: "Postanowienia ogólne", text: "Strona internetowa hodowli Wolfe Vom Katzenberg ma charakter informacyjny i służy prezentacji hodowli, psów oraz informacji o miotach.\n\nKorzystanie ze strony oznacza akceptację niniejszego regulaminu." },
      { heading: "Zasady korzystania ze strony", text: "Użytkownik zobowiązuje się do korzystania ze strony w sposób zgodny z obowiązującym prawem oraz dobrymi obyczajami.\n\nZabronione jest publikowanie treści obraźliwych lub niezgodnych z prawem." },
      { heading: "Prawa autorskie", text: "Wszystkie materiały znajdujące się na stronie, w tym teksty, zdjęcia oraz grafiki, są własnością Hodowli Wolfe Vom Katzenberg.\n\nKopiowanie i rozpowszechnianie materiałów bez zgody właściciela strony jest zabronione." },
    ]
  },
  "warunki-rezerwacji": {
    title: "Warunki rezerwacji szczenięcia",
    sections: [
      { heading: null, list: [
        "Rezerwacja szczenięcia odbywa się po wcześniejszym kontakcie z hodowlą.",
        "Hodowla Wolfe Vom Katzenberg zastrzega sobie prawo do wyboru odpowiedniego domu dla każdego szczenięcia.",
        "Dobro psa jest zawsze najważniejsze.",
        "Szczegóły dotyczące rezerwacji ustalane są indywidualnie z przyszłym właścicielem.",
        "Szczenię może opuścić hodowlę w odpowiednim wieku i po spełnieniu wszystkich warunków zdrowotnych.",
        "Nowy właściciel otrzymuje informacje dotyczące żywienia, pielęgnacji oraz dalszego prowadzenia psa."
      ]}
    ]
  },
  "cookies": {
    title: "Polityka cookies",
    sections: [
      { heading: null, text: "Strona internetowa może wykorzystywać pliki cookies w celu zapewnienia prawidłowego działania strony oraz tworzenia anonimowych statystyk odwiedzin." },
      { heading: null, text: "Cookies to niewielkie pliki zapisywane na urządzeniu użytkownika podczas korzystania ze strony." },
      { heading: null, text: "Użytkownik może w każdej chwili zmienić ustawienia dotyczące cookies w swojej przeglądarce internetowej." },
    ]
  }
};

const KennelLegal = () => {
  const { slug } = useParams();
  const page = legalPages[slug];

  if (!page) return <div className="text-center py-24 text-[#B8B8B8]">Strona nie znaleziona</div>;

  return (
    <div>
      <section className="bg-[#141416] border-b border-[#2A2A2D] px-6 md:px-12 pt-16 pb-20 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[300px] bg-[#D4AF37]/[0.03] rounded-full blur-[100px] -translate-y-1/2 translate-x-1/4" />
        <div className="max-w-4xl mx-auto relative">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <TypeWriterText />
            <h1 className="font-serif text-[clamp(1.8rem,3vw,3rem)] text-[#F5F5F5] mb-4">{page.title}</h1>
            <div className="w-16 h-px bg-[#D4AF37]/30" />
          </motion.div>
        </div>
      </section>

      <section className="px-6 md:px-12 py-16 max-w-4xl mx-auto">
        <div className="space-y-10">
          {page.sections.map((section, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
              {section.heading && (
                <h2 className="text-[#F5F5F5] font-serif text-lg mb-4">{section.heading}</h2>
              )}
              {section.text && (
                <div className="text-[#B8B8B8] text-sm leading-relaxed whitespace-pre-line">{section.text}</div>
              )}
              {section.list && (
                <ul className="mt-3 space-y-2">
                  {section.list.map((item, j) => (
                    <li key={j} className="text-[#B8B8B8] text-sm leading-relaxed flex items-start gap-3">
                      <span className="text-[#D4AF37] mt-0.5 flex-shrink-0">&#8226;</span>
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </motion.div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-[#2A2A2D]">
          <p className="text-[#B8B8B8]/40 text-xs">
            Dane kontaktowe: Hodowla Wolfe Vom Katzenberg | Tel: +48 663 746 095 | E-mail: katzenberg.hodowla@gmail.com
          </p>
        </div>
      </section>
    </div>
  );
};

export default KennelLegal;
